<template>
	<div>
		<Header />

		<div id="dashboard" class="container_width">
        	<!-- <div v-if="nm_partner" class="sansation menu_font mt-4 mb-10 d-flex align-center"> -->
				<!-- <div class="d-inline menu_title_divider font-weight-black pr-10 mr-8 py-2">All Projects</div> -->
			<!-- </div> -->
			<!-- <div v-else class="sansation menu_font mt-4 mb-10 d-flex align-center"> -->
			<div class="sansation menu_font mt-4 mb-10 d-flex align-center">
				<div class="d-inline menu_title_divider font-weight-black pr-10 mr-8 py-2">
					My Projects
				</div>
				<div class="d-inline ml-3 mr-5">
					<a v-if="project_type != 'current'" class="px-4 projecttype" @click="loadProjects('current')">Current</a>
					<div v-if="project_type == 'current'" class="px-4 projecttype_active">Current</div>
				</div>
				<div class="d-inline mx-6">
					<a v-if="project_type != 'archived'" class="px-4 projecttype" @click="loadProjects('archived')">Archived</a>
					<div v-if="project_type == 'archived'" class="px-4 projecttype_active">Archived</div>
				</div>
			</div>

			<div v-if="gatheringProjects" class="text-center py-12" style="width: 100%; margin-top:12rem">
				<v-progress-circular
					indeterminate 
					color="error darken-3" 
					class="my-12" 
					size="100" 
					width="8">
				</v-progress-circular>
			</div>

			<div v-else>
				<v-alert
					v-if="showNoProjects"
					class="my-12 py-2 avenir_book project_title grey--text text--darken-2"
					color="white"
					prominent
					border="left"
					elevation="2">
					<v-icon large class="my-2 mx-4 grey--text">mdi-information</v-icon>There are no {{ project_type }} projects to show at this time.
				</v-alert>

				<v-row v-else no-gutters align="stretch">
					<!-- <v-col v-if="nm_partner" cols="12" no-gutters class="ma-0 pa-0">
						<PartnerProjects />
					</v-col>

					<v-col v-if="!nm_partner" :cols="buyerProject.length ? '9' : '12'" class="ma-0 pa-0"> -->
					<v-col :cols="buyerProject.length || nm_partner ? '9' : '12'" class="ma-0 pa-0">
						<DashProjects 
							:projects="projects"
							:buyerProject="buyerProject[0]"
							:project_type="project_type"
							:authUser="authUser"  />
					</v-col>
					<v-col v-if="nm_partner" cols="3" class="ma-0 pa-0 d-flex justify-end">
						<!-- <NmReportGen /> -->
					</v-col>
					<v-col v-if="buyerProject.length && !nm_partner" cols="3" class="ma-0 pa-0">
						<DashListings 
							direction="vertical"
							:authUser="authUser" />
					</v-col>
				</v-row>
			</div>
      	</div>
    </div>
</template>

<script>
	import axios from "axios";
	import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';

	import Header from './Header'
	import DashProjects from './DashProjects'
	import DashListings from './DashListings';
	import PartnerProjects from './PartnerProjects';
	import NmReportGen from './NmReportGen';
  
	export default {
    	name: 'Dashboard',
    	components: {
        	Header,
        	DashProjects,
			DashListings,
			PartnerProjects,
			NmReportGen
      	},
      
	 	data () {
        	return {
				projects: [],
            	project_type : 'current',
				activeProjects: [],
				archivedProjects: [],
				buyerProject: [],
				gatheringProjects: false,
				showNoProjects: false,
				authUser: {
					id: String,
					group: String,
					name: String
				},
				nm_partner: false
			}
      	},

		// watch: {
        //     project_type ( val ) {
        //       this.loadProjects( val );
        //     }
		// },

		created () {
        	document.title = 'SRG myCompass: Dashboard'
    	},

		mounted () {
			this.initDashboard()
		},
	  	
		methods: {
			initDashboard: async function () {
				await this.checkUser()
				this.nm_partner = this.authUser.group == 'nm_partner_firm' ? true : false
				this.projects = await this.getActiveProjects( false )
			},

			checkUser: async function () {
				try {	
					const validated_user = await axios.get(`${appUrls.api}/api/user_check`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})
					
					if(validated_user.data.outcome) {    
						this.authUser.id = validated_user.data.user_data.id
						this.authUser.group = validated_user.data.user_data.group
						this.authUser.name = validated_user.data.user_data.name
					} else {
						console.log(validated_user.data.message)
					}
				
				} catch (error) {
                    console.log(error);
                }
			},

			loadProjects: async function (type) {
                this.project_type = type
				if (this.project_type == 'current') {
					this.projects = this.activeProjects.length || this.buyerProject.length ? this.activeProjects : await this.getActiveProjects( false ) 
				} else if (this.project_type == 'archived') {
					this.projects = this.archivedProjects.length ? this.archivedProjects : await this.getArchivedProjects( true ) 
				}
      },

			getActiveProjects: async function ( is_archived ) {
				try {
					if ( !this.activeProjects.length ) this.gatheringProjects = true;

					const active_projects = await axios.get(`${appUrls.api}/api/user_projects/${this.authUser.id}/${is_archived}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})

					if ( active_projects.data.outcome ) {
						const these_projects = active_projects.data.projects.length ? active_projects.data.projects : []

						this.buyerProject = these_projects.filter(prj => { return prj.modinfo.module_key == 'buyer' })
						this.activeProjects = these_projects.filter(prj => { return prj.modinfo.module_key != 'buyer' && !prj.modinfo.isSubmodule })

						this.gatheringProjects = false
						if ( this.activeProjects.length || this.buyerProject.length ) { 
							this.showNoProjects = false
							this.activeProjects = this.activeProjects.sort((a, b) => a.status.localeCompare(b.status)).sort((x, y) => x.close_date - y.close_date).reverse();
						} else {
							this.showNoProjects = true
							this.activeProjects=[]
						}

						return this.activeProjects
					}
                } catch ( err ) {
                    console.log(err);
                }
            },

			getArchivedProjects: async function ( is_archived ) {
				try {
					if (  !this.archivedProjects.length ) this.gatheringProjects = true

					const archived_projects = await axios.get(`${appUrls.api}/api/user_projects/${this.authUser.id}/${is_archived}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})
                
					if ( archived_projects.data.outcome ) {
						const these_projects = archived_projects.data.projects.length ? archived_projects.data.projects : []
						this.archivedProjects = these_projects.filter(prj => { return prj.modinfo.module_key != 'buyer' && !prj.modinfo.isSubmodule })
						
						this.gatheringProjects = false
						if ( this.archivedProjects.length ) {
							this.showNoProjects = false
							this.archivedProjects = these_projects.sort((a, b) => a.status.localeCompare(b.status)).sort((x, y) => x.close_date - y.close_date).reverse()
							// this.projects.splice(0, this.projects.length, ...this.archivedProjects)
						} else {
							this.showNoProjects = true
							this.archivedProjects=[]
						}

						return this.archivedProjects
					}
                } catch ( err ) {
                    console.log(err);
                }
            }
		}
  }
</script>

<style scoped>
	.button_link {
		text-decoration-line: none;
	}
	#dashboard {
		min-height: 60vh;
		margin: 0 auto;
	}
	.menu_font {
		color: #5F6062;
		font-size: 1.2rem!important;
		font-weight: 400;
		/* letter-spacing: .025em!important; */
		line-height: 1.7rem;
	}
	.menu_title_divider {
		border-right: 1px solid #5F6062
	}
	.title {
		font-family: 'SansationBold', sans-serif !important;
		font-size: 32px !important;
	}
	.projecttype {
		color: #5F6062;
	}
  	.projecttype_active {
		position: relative;
		color: #0096A6;
		font-weight: 500;
		text-decoration-line: none;
	}
	.projecttype_active::before {
		content: '';
		position: absolute;
		bottom: -20px;
		left: 0;
		right: 0;
		height: 4px;
		border-radius: 8px;
		background-color: #0096A6;
	}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue